export const Role = {
  OWNER: "owner",
  ADMIN: "admin",
  DEPUTY_ADMIN: "deputy_admin",
  CARE_SUPERVISOR: "supervisor",
};

export const basePlanModules = [
  {
    value: "Dashboard",
    label: "DashBoard",
    link: "/dashboard",
    src: `/admin/images/adminDashboard.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Clients",
    label: "Clients",
    link: "/clients",
    src: `/admin/images/adminClients.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "CareTeam",
    label: "Care Team",
    link: "/careteam",
    src: `/admin/images/adminCareTeam.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Scheduler",
    label: "Rota",
    link: "/shift",
    src: `/admin/images/adminRota.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
];

export const AdvancePlanModules = [
  {
    value: "Reports",
    label: "Reports",
    link: "/report",
    src: `/admin/images/adminReports.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Payroll",
    label: "Payroll",
    link: "/payroll",
    src: `/admin/images/adminpayroll.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Invoicing",
    label: "Invoicing",
    link: "/invoicing",
    src: `/admin/images/adminInvoicing.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
];

export const turboPlanModules = [
  {
    value: "Medicines",
    label: "eMAR",
    link: "/emar",
    src: `/admin/images/adminEmar.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Sales Funnel",
    label: "Sales Funnel",
    link: "/salesfunnel",
    src: `/admin/images/adminSalesFunnel.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Messaging",
    label: "Messaging",
    link: "/messaging",
    src: `/admin/images/adminMessaging.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
];

export const modules = [
  {
    value: "Dashboard",
    label: "DashBoard",
    link: "/dashboard",
    src: `/admin/images/adminDashboard.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Clients",
    label: "Clients",
    link: "/clients",
    src: `/admin/images/adminClients.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "CareTeam",
    label: "Care Team",
    link: "/careteam",
    src: `/admin/images/adminCareTeam.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Scheduler",
    label: "Rota",
    link: "/shift",
    src: `/admin/images/adminRota.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Reports",
    label: "Reports",
    link: "/report",
    src: `/admin/images/adminReports.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Payroll",
    label: "Payroll",
    link: "/payroll",
    src: `/admin/images/adminpayroll.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Invoicing",
    label: "Invoicing",
    link: "/invoicing",
    src: `/admin/images/adminInvoicing.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Medicines",
    label: "eMAR",
    link: "/emar",
    src: `/admin/images/adminEmar.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "Sales Funnel",
    label: "Sales Funnel",
    link: "/salesfunnel",
    src: `/admin/images/adminSalesFunnel.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "messaging",
    label: "Messaging",
    link: "/messaging",
    src: `/admin/images/adminMessaging.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
  {
    value: "userole",
    label: "Access Management",
    link: "/userole",
    src: `/admin/images/adminMessaging.svg`,
    isAdding: true,
    isEditing: true,
    isDeleting: true,
    isViewing: true,
    isDisabled: false,
    isPermission: false,
    isVerify: false,
    isShow: true,
    isHide: false,
  },
];

export const Roles = [
  { value: 0, role: Role.OWNER, label: "Owner" },
  { value: 1, role: Role.ADMIN, label: "Admin" },
  { value: 2, role: Role.DEPUTY_ADMIN, label: "Deputy Admin" },
  { value: 3, role: Role.CARE_SUPERVISOR, label: "Care Supervisor" },
];

export const AccessManagementDefaultRoles = [
  {
    roleId: Role.OWNER,
    Modules: [
      {
        moduleName: "Dashboard",
        label: "Dashboard",
        value: "Dashboard",
        access: "full",
      },
      {
        moduleName: "Clients",
        access: "full",
        children: [
          {
            moduleName: "Add Clients",
            access: "full",
          },
          {
            moduleName: "Create/Delete Groups",
            access: "full",
          },
          {
            moduleName: "Profile",
            access: "full",
          },
          {
            moduleName: "Contacts",
            access: "full",
          },
          {
            moduleName: "Compliance Docs",
            access: "full",
          },
          {
            moduleName: "Care Plan",
            access: "full",
          },
          {
            moduleName: "Journal",
            access: "full",
          },
        ],
      },
      {
        moduleName: "CareTeam",
        access: "full",
        children: [
          {
            moduleName: "Add/Delete CareGiver",
            access: "full",
          },
          {
            moduleName: "Profile",
            access: "full",
          },
          {
            moduleName: "Docs",
            access: "full",
          },
          {
            moduleName: "Training",
            access: "full",
          },
          {
            moduleName: "Journal",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Scheduler",
        access: "full",
        children: [
          {
            moduleName: "Scheduler",
            access: "full",
          },
          {
            moduleName: "Task Status",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Reports",
        access: "full",
      },
      {
        moduleName: "Payroll",
        access: "full",
      },
      {
        moduleName: "Invoicing",
        access: "full",
      },
      {
        moduleName: "Medicines",
        access: "full",
        children: [
          {
            moduleName: "Scheduler",
            access: "full",
          },
          {
            moduleName: "Medicines",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Sales Funnel",
        access: "full",
        children: [
          {
            moduleName: "Sales Overview",
            access: "full",
          },
          {
            moduleName: "Leads Management",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Messaging",
        access: "full",
      },
      {
        moduleName: "MultiSite Dashboard",
        access: "full",
        children: [
          {
            moduleName: "Operations",
            access: "full",
          },
          {
            moduleName: "Finance",
            access: "full",
          },
        ],
      },
    ],
  },
  {
    roleId: Role.ADMIN,
    Modules: [
      {
        moduleName: "Dashboard",
        label: "Dashboard",
        value: "Dashboard",
        access: "full",
      },
      {
        moduleName: "Clients",
        access: "full",
        children: [
          {
            moduleName: "Add Clients",
            access: "full",
          },
          {
            moduleName: "Create/Delete Groups",
            access: "full",
          },
          {
            moduleName: "Profile",
            access: "full",
          },
          {
            moduleName: "Contacts",
            access: "full",
          },
          {
            moduleName: "Compliance Docs",
            access: "full",
          },
          {
            moduleName: "Care Plan",
            access: "full",
          },
          {
            moduleName: "Journal",
            access: "full",
          },
        ],
      },
      {
        moduleName: "CareTeam",
        access: "full",
        children: [
          {
            moduleName: "Add/Delete CareGiver",
            access: "full",
          },
          {
            moduleName: "Profile",
            access: "full",
          },
          {
            moduleName: "Docs",
            access: "full",
          },
          {
            moduleName: "Training",
            access: "full",
          },
          {
            moduleName: "Journal",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Scheduler",
        access: "full",
        children: [
          {
            moduleName: "Scheduler",
            access: "full",
          },
          {
            moduleName: "Task Status",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Reports",
        access: "full",
      },
      {
        moduleName: "Payroll",
        access: "no",
      },
      {
        moduleName: "Invoicing",
        access: "full",
      },
      {
        moduleName: "Medicines",
        access: "full",
        children: [
          {
            moduleName: "Scheduler",
            access: "full",
          },
          {
            moduleName: "Medicines",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Sales Funnel",
        access: "no",
        children: [
          {
            moduleName: "Sales Overview",
            access: "no",
          },
          {
            moduleName: "Leads Management",
            access: "no",
          },
        ],
      },
      {
        moduleName: "Messaging",
        access: "full",
      },
      {
        moduleName: "MultiSite Dashboard",
        access: "no",
        children: [
          {
            moduleName: "Operations",
            access: "no",
          },
          {
            moduleName: "Finance",
            access: "no",
          },
        ],
      },
    ],
  },
  {
    roleId: Role.DEPUTY_ADMIN,
    Modules: [
      {
        moduleName: "Dashboard",
        label: "Dashboard",
        value: "Dashboard",
        access: "full",
      },
      {
        moduleName: "Clients",
        access: "full",
        children: [
          {
            moduleName: "Add/Delete Clients",
            access: "no",
          },
          {
            moduleName: "Create/Delete Groups",
            access: "no",
          },
          {
            moduleName: "Profile",
            access: "full",
          },
          {
            moduleName: "Contacts",
            access: "full",
          },
          {
            moduleName: "Compliance Docs",
            access: "full",
          },
          {
            moduleName: "Care Plan",
            access: "full",
          },
          {
            moduleName: "Journal",
            access: "full",
          },
        ],
      },
      {
        moduleName: "CareTeam",
        access: "full",
        children: [
          {
            moduleName: "Add/Delete CareGiver",
            access: "no",
          },
          {
            moduleName: "Profile",
            access: "full",
          },
          {
            moduleName: "Docs",
            access: "full",
          },
          {
            moduleName: "Training",
            access: "full",
          },
          {
            moduleName: "Journal",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Scheduler",
        access: "full",
        children: [
          {
            moduleName: "Scheduler",
            access: "full",
          },
          {
            moduleName: "Task Status",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Reports",
        access: "full",
      },
      {
        moduleName: "Payroll",
        access: "no",
      },
      {
        moduleName: "Invoicing",
        access: "no",
      },
      {
        moduleName: "Medicines",
        access: "full",
        children: [
          {
            moduleName: "Scheduler",
            access: "full",
          },
          {
            moduleName: "Medicines",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Sales Funnel",
        access: "no",
        children: [
          {
            moduleName: "Sales Overview",
            access: "no",
          },
          {
            moduleName: "Leads Management",
            access: "no",
          },
        ],
      },
      {
        moduleName: "Messaging",
        access: "full",
      },
      {
        moduleName: "MultiSite Dashboard",
        access: "no",
      },
      {
        moduleName: "MultiSite Dashboard",
        access: "no",
        children: [
          {
            moduleName: "Operations",
            access: "no",
          },
          {
            moduleName: "Finance",
            access: "no",
          },
        ],
      },
    ],
  },
  {
    roleId: Role.CARE_SUPERVISOR,
    Modules: [
      {
        moduleName: "Dashboard",
        label: "Dashboard",
        value: "Dashboard",
        access: "view",
      },
      {
        moduleName: "Clients",
        access: "full",
        children: [
          {
            moduleName: "Add Clients",
            access: "no",
          },
          {
            moduleName: "Create/Delete Groups",
            access: "no",
          },
          {
            moduleName: "Profile",
            access: "view",
          },
          {
            moduleName: "Contacts",
            access: "view",
          },
          {
            moduleName: "Compliance Docs",
            access: "full",
          },
          {
            moduleName: "Care Plan",
            access: "full",
          },
          {
            moduleName: "Journal",
            access: "full",
          },
        ],
      },
      {
        moduleName: "CareTeam",
        access: "full",
        children: [
          {
            moduleName: "Add/Delete CareGiver",
            access: "no",
          },
          {
            moduleName: "Profile",
            access: "view",
          },
          {
            moduleName: "Docs",
            access: "full",
          },
          {
            moduleName: "Training",
            access: "full",
          },
          {
            moduleName: "Journal",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Scheduler",
        access: "full",
        children: [
          {
            moduleName: "Scheduler",
            access: "full",
          },
          {
            moduleName: "Task Status",
            access: "full",
          },
        ],
      },
      {
        moduleName: "Reports",
        access: "full",
      },
      {
        moduleName: "Payroll",
        access: "no",
      },
      {
        moduleName: "Invoicing",
        access: "no",
      },
      {
        moduleName: "Medicines",
        access: "full",
        children: [
          {
            moduleName: "Scheduler",
            access: "full",
          },
          {
            moduleName: "Medicines",
            access: "view",
          },
        ],
      },
      {
        moduleName: "Sales Funnel",
        access: "no",
        children: [
          {
            moduleName: "Sales Overview",
            access: "no",
          },
          {
            moduleName: "Leads Management",
            access: "no",
          },
        ],
      },
      {
        moduleName: "Messaging",
        access: "full",
      },
      {
        moduleName: "MultiSite Dashboard",
        access: "no",
      },
      {
        moduleName: "MultiSite Dashboard",
        access: "no",
        children: [
          {
            moduleName: "Operations",
            access: "no",
          },
          {
            moduleName: "Finance",
            access: "no",
          },
        ],
      },
    ],
  },
];

export const planFeaturesList = [
  {
    label: "Dashboard",
    value: "1",
  },
  {
    label: "Clients",
    value: "2",
  },
  {
    label: "Add Clients",
    value: "3",
  },
  {
    label: "Create Groups",
    value: "4",
  },
  {
    label: "Profile",
    value: "5",
  },
  {
    label: "Contacts",
    value: "6",
  },
  {
    label: "Compliance Docs",
    value: "7",
  },
  {
    label: "Care Plan",
    value: "8",
  },
  {
    label: "Journal",
    value: "9",
  },
  {
    label: "CareTeam",
    value: "10",
  },
  {
    label: "Add/Delete CareGiver",
    value: "11",
  },
  {
    label: "Create Groups",
    value: "12",
  },
  {
    label: "Profile",
    value: "13",
  },
  {
    label: "Docs",
    value: "14",
  },
  {
    label: "Training",
    value: "15",
  },
  {
    label: "Journal",
    value: "16",
  },
  {
    label: "Payroll",
    value: "17",
  },
  {
    label: "Scheduler",
    value: "18",
  },
  {
    label: "Scheduler",
    value: "19",
  },
  {
    label: "Task Status",
    value: "20",
  },
  {
    label: "Reports",
    value: "21",
  },
  {
    label: "Medicines",
    value: "22",
  },
  {
    label: "Scheduler",
    value: "23",
  },
  {
    label: "Add Medicines",
    value: "24",
  },
  {
    label: "Invoicing",
    value: "25",
  },
  {
    label: "Sales Funnel",
    value: "26",
  },
  {
    label: "Sales Overview",
    value: "27",
  },
  {
    label: "Move Ins/Outs",
    value: "28",
  },
  {
    label: "Leads Management",
    value: "29",
  },
  {
    label: "Messaging",
    value: "30",
  },
  {
    label: "Chats",
    value: "31",
  },
  {
    label: "Create Groups",
    value: "32",
  },
];

export const currencyList = [
  { value: "CAD", label: "CAD" },
  { value: "GBP", label: "GBP" },
  { value: "USD", label: "USD" },
];

export const billFrequencyList = [
  { value: "Monthly", label: "Monthly" },
  { value: "Yearly", label: "Yearly" },
];

export const discountList = [
  { value: "Fixed", label: "Fixed" },
  { value: "%", label: "%" },
];

export const redemptionListDetails = [
  { value: "one_time", label: "One Time" },
  { value: "indefinite", label: "Indefinite" },
  {
    value: "fewno",
    label: "Few No. of Times (Applied at each time an invoice is issued)",
  },
];

export const taskImages = [
  {
    value: 1,
    Ctg: "Personal Care",
    image: `/admin/images/s1.svg`,
  },
  {
    value: 2,
    Ctg: "Health",
    image: `/admin/images/s2.svg`,
  },
  {
    value: 3,
    Ctg: "Mobility",
    image: `/admin/images/s3.svg`,
  },
  {
    value: 4,
    Ctg: "Diet",
    image: `/admin/images/s4.svg`,
  },
  {
    value: 5,
    Ctg: "Social",
    image: `/admin/images/s5.svg`,
  },
  {
    value: 6,
    Ctg: "PRN Meds",
    image: `/admin/images/s6.svg`,
  },
  {
    value: 7,
    Ctg: "Housekeeping",
    image: `/admin/images/s7.svg`,
  },
  {
    value: 8,
    Ctg: "Report Incident",
    image: `/admin/images/s8.svg`,
  },
];
